export default __webpack_public_path__ + "static/media/uwt.a97170d0.png";